export interface GOLD_COUNTRY {
  major_cities_data: GOLD_DATA[];
  last_ten_days_data: GOLD_DATA[];
  today: GOLD_DATA;
}

export interface GOLD_CITY {
  last_ten_days_data: GOLD_DATA[];
  today: GOLD_DATA;
}

export interface GOLD_DATA {
  date: string;
  city: string;
  carat24: CARAT_DATA;
  carat22: CARAT_DATA;
}

export interface CARAT_DATA {
  ratePerGram: number;
  change: number;
}

interface CHANGE {
  carat24: number;
  carat22: number;
}

interface DATE_WISE_GOLD_RATE {
  date: string;
  carat24: MONTH_WISE_RATE;
  carat22: MONTH_WISE_RATE;
}

export interface MONTH_WISE_DATA {
  monthName: string;
  year: number;
  startDate: DATE_WISE_GOLD_RATE;
  endDate: DATE_WISE_GOLD_RATE;
  highestRate: DATE_WISE_GOLD_RATE;
  lowestRate: DATE_WISE_GOLD_RATE;
  change: CHANGE;
  overallPerformance: CHANGE;
}

export interface HISTORICAL_DATA {
  goldRateOn: string;
  subRows: {
    goldRateOn: string;
    carat22: string;
    carat24: string;
  }[];
}

//Silver

export interface HISTORICAL_DATA_SILVER {
  goldRateOn: string;
  subRows: {
    goldRateOn: string;
    ratePerGram: string;
    ratePerKg: string;
  }[];
}

export interface MONTH_WISE_DATA_SILVER {
  monthName: string;
  year: number;
  startDate: SILVER_DATA;
  endDate: SILVER_DATA;
  highestRate: SILVER_DATA;
  lowestRate: SILVER_DATA;
  change: number;
  overallPerformance: number;
}

export interface SILVER_COUNTRY {
  major_cities_data: SILVER_DATA[];
  last_ten_days_data: SILVER_DATA[];
  today: SILVER_DATA;
}

export interface SILVER_CITY {
  last_ten_days_data: SILVER_DATA[];
  today: SILVER_DATA;
}

export interface SILVER_DATA extends CARAT_DATA {
  date: string;
  city: string;
}

interface MONTH_WISE_RATE {
  ratePerGram: number;
}

export interface ALL_CITIES {
  major_city: string[];
  metro_city: string[];
  capital?: string[];
  country: string[];
}

export interface GRAM_WISE_CARAT_RATE {
  carat: string;
  rate: number;
  change: number;
}

export enum METALS {
  GOLD = 'gold',
  SILVER = 'silver',
}

export enum INTERVALS {
  '1W' = '1W',
  '1M' = '1M',
  '1Y' = '1Y',
  '3Y' = '3Y',
  '5Y' = '5Y',
  '40Y' = '40Y',
}
